export let languages = [
    {
        id: 1,
        name: 'Python',
        skill: 'proficient',
        img: require('../Assets/languages/python.jpg')
    },
    {
        id: 2,
        name: 'C',
        skill: 'proficient',
        img: require('../Assets/languages/c.png')
    },
    {
        id: 3,
        name: 'Java',
        skill: 'intermediate',
        img: require('../Assets/languages/java.png')
    },
    {
        id: 4,
        name: 'JavaScript',
        skill: 'proficient',
        img: require('../Assets/languages/js.png')
    },
    {
        id: 5,
        name: 'HTML',
        skill: 'proficient',
        img: require('../Assets/languages/html.png')
    },
    {
        id: 6,
        name: 'CSS',
        skill: 'proficient',
        img: require('../Assets/languages/css.png')
    }
]
// frameworks, libraries and databases
export let frameworks = [
    
    {
        id: 1,
        name: 'React',
        skill: 'advance',
        img: require('../Assets/languages/react.png')
    },
    {
        id: 2,
        name: 'Pandas',
        skill: 'intermediate',
        img: require('../Assets/languages/pandas.png')
    },
    {
        id: 3,
        name: 'ScikitLearn',
        skill: 'intermediate',
        img: require('../Assets/languages/scikit.png')
    },
    {
        id: 4,
        name: 'TenserFlow',
        skill: 'begginer',
        img: require('../Assets/languages/tf.png')
    },
    {
        id: 5,
        name: 'Django',
        skill: 'intermediate',
        img: require('../Assets/languages/django.png')
    },
    {
        id: 6,
        name: 'Flask',
        skill: 'begginer',
        img: require('../Assets/languages/flask.png')
    },
    {
        id: 7,
        name: 'NodeJS',
        skill: 'beginner',
        img: require('../Assets/languages/node.png')
    },
    {
        id: 8,
        name: 'Express',
        skill: 'begginer',
        img: require('../Assets/languages/express.png')
    },
    {
        id: 9,
        name: 'PostgreSQL',
        skill: 'begginer',
        img: require('../Assets/languages/postgre.png')
    }
]


export let tools = [
    
    {
        id: 1,
        name: 'Git',
        skill: 'intermediate',
        img: require('../Assets/languages/git.png')
    },
    {
        id: 2,
        name: 'VSCode',
        skill: 'intermediate',
        img: require('../Assets/languages/vs.jpg')
    },
    {
        id: 3,
        name: 'Jupyter',
        skill: 'intermediate',
        img: require('../Assets/languages/jupyter.png')
    },
    {
        id: 4,
        name: 'Unix',
        skill: 'intermediate',
        img: require('../Assets/languages/unix.jpg')
    },
    {
        id: 5,
        name: 'Bootstrap',
        skill: 'intermediate',
        img: require('../Assets/languages/bootstrap.png')
    },
    {
        id: 6,
        name: 'MUI',
        skill: 'intermediate',
        img: require('../Assets/languages/mui.png')
    },
    {
        id: 7,
        name: 'Firebase',
        skill: 'novice',
        img: require('../Assets/languages/fb.png')
    },
    {
        id: 8,
        name: 'AWS',
        skill: 'novice',
        img: require('../Assets/languages/aws.png')
    },
    
]